import t from "./_baseGetTag.js";
import m from "./isObjectLike.js";
var r = "[object Symbol]";
function i(o) {
  return typeof o == "symbol" || m(o) && t(o) == r;
}
export {
  i as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/lodash-es@4.17.21/~/lodash-es/isSymbol.js
// module id = 317
// module chunks = 67